export const presenceSteps = [
  {
    label: "show up",
    detail: "A clear website gives the brand a solid home.",
  },
  {
    label: "be found",
    detail: "SEO and GEO put it in the right searches and answers.",
  },
  {
    label: "earn trust",
    detail: "Useful content earns attention and belief.",
  },
  {
    label: "get chosen",
    detail: "One connected presence makes the next step obvious.",
  },
] as const;

export const services = [
  {
    name: "Websites",
    problem: "People arrive. The site does not make the case.",
    description:
      "Fast, clear websites that make the business easier to understand and choose.",
    outcome: "clarity → trust → action",
  },
  {
    name: "SEO + GEO",
    problem: "The right people are searching. The brand is missing.",
    description:
      "Pages and signals that help the brand appear in search and AI answers.",
    outcome: "search → answer → visit",
  },
  {
    name: "Content",
    problem: "The brand has something to say. It is not compounding.",
    description:
      "Useful content that earns reach, trust and repeat attention.",
    outcome: "idea → asset → reach",
  },
] as const;

export const callFixes = [
  "The first 3 changes, in order.",
  "What is holding the rest back.",
  "One straightforward next step.",
] as const;
